export default __webpack_public_path__ + "static/media/9.d2b55e32.mp3";